<!--详情页面-->
<template>
  <el-dialog
    title="处理信息"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <el-table
      :data="handlelogData"
      :height="tableHeight(81)"
      size="mini"
      stripe
      border
      style="width: 100%;"
    >
      <el-table-column
        type="index"
        width="50"
        label="序号"
        align="center">
      </el-table-column>
      <el-table-column
        prop="erpserial"
        label="订单号"
        align="center"
        header-align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="adddate"
        label="打印时间"
        align="center"
        header-align="center"
        width="140"
      >
      </el-table-column>
      <el-table-column
        prop="uname"
        label="名称"  width="60"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="dname"
        label="部门"
        align="left"  width="120"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="casestepname"
        label="当前处理步骤"
        align="left"  width="140"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="left"
        header-align="center"
      >
      </el-table-column>

    </el-table>
  </el-dialog>
</template>


<script>
  import {getListData} from '@/api/set/handlelog';

  export default {
    name: 'wwrt',
    data() {
      return {
        dialogSeeVisible: false,
        handlelogData: [],//打印日志
      }
    },
    methods: {

      show() {
        this.dialogSeeVisible = true;
      },
      initData(groupguid) {
        getListData({groupguid: groupguid}).then(response => {
          if (response.data.obj)
            this.handlelogData = response.data.obj

        })
      }

    },
    mounted() {

    },
    components: {}

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/HandlelogList.vue